import React, { useEffect, useState } from 'react';
import InventoryData from '../../Datas/InventoryData';
import { FaExclamationTriangle, FaBox, FaClipboardList, FaCheckCircle } from 'react-icons/fa';
import { WardDetails } from '../../Datas/WardDetails';
import './Notification.css';

const NotificationSidebar = ({ role }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const today = new Date();
    const notificationList = [];
    const lowStockThreshold = 100; 

    const checkExpiryAndStock = (item) => {
      const expiryDate = new Date(item.expiryDate);
      const daysToExpiry = (expiryDate - today) / (1000 * 60 * 60 * 24);

      if (daysToExpiry <= 120 && daysToExpiry >= 0) {
        notificationList.push({
          type: 'expiry',
          message: `${item.name} is expiring in ${Math.floor(daysToExpiry)} days.`,
          color: 'purple',  // Background color for the notification
          iconColor: 'red',  // Color for the icon's background
          icon: <FaExclamationTriangle />,
        });
      }

      if (item.tablets < lowStockThreshold) {
        notificationList.push({
          type: 'stock',
          message: `${item.name} is low on stock (${item.tablets} tablets left).`,
          color: 'purple',  // Background color for the notification
          iconColor: 'blue',  // Color for the icon's background
          icon: <FaBox />,
        });
      }
    };

    if (role === 'pharmacist') {
      InventoryData.forEach(item => checkExpiryAndStock(item));

      const indentDepartments = ['---------']; 
      indentDepartments.forEach(department => {
        notificationList.push({
          type: 'indent',
          message: `A new indent was sent by the ${department} department.`,
          color: 'purple',  // Background color for the notification
          iconColor: 'green',  // Color for the icon's background
          icon: <FaClipboardList />,
        });
      });
    }

    if (role === 'distributor') {
      InventoryData.forEach(item => checkExpiryAndStock(item));
    }

    if (role === 'ward') {
      WardDetails.forEach(ward => {
        ward.inventory.forEach(item => {
          checkExpiryAndStock(item);

          if (item.stockLevel <= 5) {
            notificationList.push({
              type: 'stock',
              message: `${item.name} is low on stock (${item.stockLevel} units left) in the ${ward.wardName} ward.`,
              color: 'purple',  // Background color for the notification
              iconColor: 'blue',  // Color for the icon's background
              icon: <FaBox />,
            });
          }

          const daysToExpiry = (new Date(item.expiryDate) - today) / (1000 * 60 * 60 * 24);
          if (daysToExpiry <= 100 && daysToExpiry >= 0) {
            notificationList.push({
              type: 'expiry',
              message: `${item.name} is expiring in ${Math.floor(daysToExpiry)} days in the ${ward.wardName} ward.`,
              color: 'purple',  // Background color for the notification
              iconColor: 'red',  // Color for the icon's background
              icon: <FaExclamationTriangle />,
            });
          }
        });
      });

      notificationList.push({
        type: 'indent-confirmed',
        message: `Indent for medication has been confirmed for the ${WardDetails[0].wardName} ward.`,
        color: 'purple',  // Background color for the notification
        iconColor: 'green',  // Color for the icon's background
        icon: <FaCheckCircle />,
      });
    }

    setNotifications(notificationList);
  }, [role]);

  const handleAction = (notification) => {
    if (notification.type === 'stock' || notification.type === 'expiry') {
      alert(`Checked inventory for ${notification.message}`);
    } else if (notification.type === 'indent') {
      alert(`Checking indent for ${notification.message}`);
    } else if (notification.type === 'indent-confirmed') {
      alert('Indent confirmed.');
    }
  };

  return (
    <div className="notification-container">
      {notifications.length > 0 ? (
        notifications.map((notification, index) => (
          <div key={index} className={`notification-card ${notification.color}`}>
            <div className="notification-icon" style={{ backgroundColor: notification.iconColor }}>
              {notification.icon}
            </div>
            <div className="notification-content">
              <p>{notification.message}</p>
              <div className="button-container">
                {notification.type === 'stock' || notification.type === 'expiry' ? (
                  <>
                    <button
                      className="action-button add-to-cart"
                      onClick={() => handleAction(notification)}
                    >
                      Add to Cart
                    </button>
                    <button
                      className="action-button check-inventory"
                      onClick={() => handleAction(notification)}
                    >
                      Check Inventory
                    </button>
                  </>
                ) : notification.type === 'indent' ? (
                  <button
                    className="action-button check-indent"
                    onClick={() => handleAction(notification)}
                  >
                    Check Indent
                  </button>
                ) : notification.type === 'indent-confirmed' ? (
                  <>
                    <button
                      className="action-button view-revised-indent"
                      onClick={handleAction}
                    >
                      View Revised Indent
                    </button>
                    <button
                      className="action-button confirm-indent"
                      onClick={handleAction}
                    >
                      Confirm
                    </button>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div>No notifications at the moment.</div>
      )}
    </div>
  );
};

export default NotificationSidebar;
